var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "margin-top" },
    [
      _vm.showModalVisualizaPdf
        ? _c("app-modal-visualiza-pdf", {
            attrs: {
              titulo: _vm.tituloModal,
              tipo: _vm.tipoModal,
              isImagem: _vm.isImagem,
              conteudo: _vm.conteudoModal,
              conteudoSemId: _vm.conteudoModalSemid,
              isVTN: false
            },
            on: { closeModal: _vm.closeModalVisualizaPdf }
          })
        : _vm._e(),
      _c(
        "div",
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showUpload,
                  expression: "showUpload"
                }
              ],
              staticClass: "upload-area",
              attrs: { id: _vm.id }
            },
            [
              _c("transition", { attrs: { name: "idle-fade" } }, [
                !_vm.loading && !_vm.success
                  ? _c(
                      "div",
                      {
                        staticClass: "content content-idle",
                        class: { "error-upload": _vm.errors.length }
                      },
                      [
                        _c("div", { staticClass: "info" }, [
                          _vm._v(
                            "Arraste e solte ou clique para selecionar um arquivo."
                          )
                        ]),
                        _c("div", { staticClass: "format" }, [
                          _vm._v(
                            "Formato(s) suportado(s): " +
                              _vm._s(this.fileType.join(", "))
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]),
              !_vm.loading && _vm.errors.length
                ? _c("span", { staticClass: "help erro" }, [
                    _vm._v(_vm._s(_vm.errors[0]))
                  ])
                : _vm._e(),
              _c(
                "transition",
                { attrs: { name: "width" } },
                [
                  _vm.loading
                    ? _c(
                        "el-row",
                        {
                          staticClass: "content content-loader",
                          style: {
                            width:
                              (_vm.percentage < 20
                                ? 20
                                : _vm.percentage
                              ).toString() + "%"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { staticClass: "column", attrs: { span: 12 } },
                            [
                              _c("div", { staticClass: "name" }, [
                                _vm._v(_vm._s(_vm.fileName))
                              ]),
                              _c("div", { staticClass: "size" }, [
                                _vm._v(_vm._s(_vm.fileSize) + " Kb")
                              ])
                            ]
                          ),
                          _c(
                            "transition",
                            { attrs: { name: "buttons-and-label-fade" } },
                            [
                              _vm.success
                                ? _c(
                                    "el-col",
                                    {
                                      staticClass: "column right float-left",
                                      attrs: { span: 12 }
                                    },
                                    [
                                      _c("div", { staticClass: "label" }, [
                                        _vm._v("Carregado com sucesso!")
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c("app-resumable", {
            ref: _vm.id,
            attrs: {
              target: "publico/upload",
              fileType: _vm.fileType,
              idDrop: _vm.id,
              idInput: _vm.id,
              fileTypeErrorCallback: _vm.fileTypeErrorCallback,
              maxSize: _vm.maxSize || null
            },
            on: {
              onSuccess: _vm.onSuccessEvent,
              onError: _vm.onErrorEvent,
              onProgress: _vm.onProgressEvent,
              fileAdded: _vm.onFileAddedEvent
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "margin-top" },
        [
          _vm.files.length > 0
            ? _c("p", { staticClass: "label" }, [_vm._v("Anexos")])
            : _vm._e(),
          _vm.files.length > 0
            ? _c(
                "el-table",
                { attrs: { data: _vm.files } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "nome", label: "Nome do Arquivo:" }
                  }),
                  _c("el-table-column", {
                    attrs: { width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _vm.isEstadoMA || _vm.isEstadoBA
                                    ? _c("app-action-button", {
                                        attrs: {
                                          icone: "eye",
                                          cor: !_vm.isDocumentoParaVisualizacao(
                                            scope.row
                                          )
                                            ? "#C0C4CC"
                                            : "#666666",
                                          text: !_vm.isDocumentoParaVisualizacao(
                                            scope.row
                                          )
                                            ? "Não é possível exibir esse arquivo"
                                            : "Visualizar Documento",
                                          disabled: !_vm.isDocumentoParaVisualizacao(
                                            scope.row
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.abrirDocumento(scope.row)
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.exibirDownload
                                    ? _c("app-action-button", {
                                        attrs: {
                                          icone: "download",
                                          cor: "#666666",
                                          text: "Baixar Documento",
                                          placement: _vm.posicaoTooltip
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.downloadDocumentoCadastro(
                                              scope.row
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.exibirDelete
                                    ? _c("app-action-button", {
                                        attrs: {
                                          icone: "trash",
                                          cor: "#666666",
                                          text: "Remover Documento"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFile(scope.row)
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.alteraFoto && scope.row.tipo.id === 150
                                    ? _c("app-action-button", {
                                        attrs: {
                                          icone: "image",
                                          cor: "#666666",
                                          text: "Mudar para assinatura"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.mudarTipo(scope.row)
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.alteraFoto && scope.row.tipo.id === 149
                                    ? _c("app-action-button", {
                                        attrs: {
                                          icone: "signature",
                                          cor: "#666666",
                                          text: "Mudar para galeria"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.mudarTipo(scope.row)
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2113681364
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10500e5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10500e5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppAnexo.vue
// module id = null
// module chunks = 